import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=d3abfbe2&scoped=true&"
import script from "./Book.vue?vue&type=script&lang=js&"
export * from "./Book.vue?vue&type=script&lang=js&"
import style0 from "./Book.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Book.vue?vue&type=style&index=1&id=d3abfbe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3abfbe2",
  null
  
)

export default component.exports